import {IManagableObject} from "../system/admin-panel/IManagableObject";

export class DeviceModelViewModel implements IManagableObject {
  Id: number = 0;
  IsChecked: boolean;
  Name: string;

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
    }
  }

  static fromJS(data: any): DeviceModelViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new DeviceModelViewModel();
    result.init(data);
    return result;
  }
}
